import React from "react";
import styles from "./Hamburger.module.scss";
import { useAppContext } from "../../../context/AppContext";
import { ReactSVG } from "react-svg";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

export const Hamburger = ({}) => {
  const { openMenu, setOpenMenu } = useAppContext();
  const { getIcon, getLabel } = useGlobalContext();
  const label = openMenu
    ? getLabel("main_menu_close_label")
    : getLabel("main_menu_label");
  return (
    <button
      onClick={() => setOpenMenu((last) => !last)}
      className={`${styles["hamburger"]} is-hidden-after-navbar-breakpoint
      ${openMenu ? `navbar-menu-burger-close ${styles["navbar-menu-burger-close"]}` : `navbar-menu-burger ${styles["navbar-menu-burger"]}`}`}
      aria-label={getLabel("arialabel_hamburger")}
      aria-controls="navbar-main"
      aria-expanded={openMenu}
    >
      {label && <span className={styles["menu-label"]}>{label}</span>}
      {openMenu ? (
        <ReactSVG
          src={getIcon("close")}
          wrapper={"svg"}
          key={"close"}
          width={"100%"}
          height={"100%"}
          beforeInjection={(svg) => {
            svg.setAttribute("alt", `Menu close Icon`);
            svg.setAttribute("aria-label", `Menu close Icon`);
          }}
        />
      ) : (
        <ReactSVG
          src={getIcon("menu")}
          wrapper={"svg"}
          key={"open"}
          width={"100%"}
          height={"100%"}
          beforeInjection={(svg) => {
            svg.setAttribute("alt", `Menu open Icon`);
            svg.setAttribute("aria-label", `Menu open Icon`);
          }}
        />
      )}
    </button>
  );
};
